import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../common/Header/Header';

const MainLayout = () => {
  return (
    <Header>
      <Outlet />
    </Header>
  );
};

export default MainLayout;